document.addEventListener('DOMContentLoaded', function () {

  const stickyBar = document.getElementById('stickyCartBar');
  if (!stickyBar) return;

  window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;

    // mobile check (768px se chhota)
    const isMobile = window.innerWidth <= 768;

    const showAt = isMobile ? 20 : 55;

    if (scrollPercent >= showAt) {
      stickyBar.style.display = 'flex';
    } else {
      stickyBar.style.display = 'none';
    }
  });

  /* ===== Plus / Minus qty ===== */
  stickyBar.addEventListener('click', function (e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;

    const wrapper = btn.closest('.sticky-cart-qty-wrapper');
    const input = wrapper.querySelector('.sticky-cart-qty-input');
    let value = parseInt(input.value, 10) || 1;

    if (btn.dataset.action === 'plus') value++;
    if (btn.dataset.action === 'minus' && value > 1) value--;

    input.value = value;
  });

});
